import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const CARTPAGE_LEGACY_FIELD_ORDER = [
  "background_color",
  "background_image"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cartPageDescriptor: _generatedCartPageDescriptor,
  cartPageBlocDefinition,
  cartPageDashboardLayout,
  cartPageConfig,
  cartPageResolveConfig,
  cartPageProperties,
} = doodBlockConfig(
  {
    name: "Cart page",
    internal_name: "Cart page",
    url: "cart",
    defaultParent: [/^Main Layout$/i],
    componentType: 'CartPageComponent',
    category: 'page',
    description: "Cart page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'top',
        name: "pages.blocks.cart-page.top.label",
        accept: 'explicitOnly',
        allowedTypes: [".*(?<!Page)"],
        slotItemFormat: 'ids',
        defaultBlocks: [
          { id: 'cart-header-block', type: 'CartHeaderBlockComponent' },
          { id: 'cart-suggestion-cards-block', type: 'CartSuggestionCardsBlockComponent' },
        ],
      },
      {
        key: 'left',
        name: "pages.blocks.cart-page.left.label",
        accept: 'explicitOnly',
        allowedTypes: [".*(?<!Page)"],
        slotItemFormat: 'ids',
        defaultBlocks: [
          { id: 'cart-item-list-block', type: 'CartItemListBlockComponent' },
          { id: 'cart-amount-block', type: 'CartMerchantAmountBlockComponent' },
        ],
      },
      {
        key: 'right',
        name: "pages.blocks.cart-page.right.label",
        accept: 'explicitOnly',
        allowedTypes: [".*(?<!Page)"],
        slotItemFormat: 'ids',
        defaultBlocks: [
          { id: 'cart-on-site-location-block', type: 'CartOnSiteLocationBlockComponent' },
          { id: 'cart-voucher-block', type: 'CartVoucherBlockComponent' },
          { id: 'cart-prepayment-block', type: 'CartPrepaymentBlockComponent' },
          { id: 'cart-tip-picker-block', type: 'CartTipPickerBlockComponent' },
          { id: 'cart-additional-information-block', type: 'CartAdditionalInformationBlockComponent' },
          { id: 'como-join-loyalty-block', type: 'ComoJoinLoyaltyBlockComponent' },
          { id: 'como-cart-gifts-block', type: 'ComoAssetListBlockComponent' },
          { id: 'como-cart-credit-balance-card-block', type: 'ComoCreditBalanceCardBlockComponent' },
          { id: 'zerosix-cart-gifts-block', type: 'ZerosixAssetListBlockComponent' },
          { id: 'pongo-cart-gifts-block', type: 'PongoAssetListBlockComponent' },
        ],
      },
      {
        key: 'footer',
        name: "pages.blocks.cart-page.footer.label",
        accept: 'explicitOnly',
        allowedTypes: ["BigFooterBlock", "LegalsFooterBlock", "HtmlBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.cart-page.background-color.label",
      }
    }),
    background_image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.cart-page.background-image.label",
        help: "pages.blocks.cart-page.background-image.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.cart-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cart-page.fieldset.appearance.label",
            fields: ["background_color", "background_image"],
          },
          {
            legend: "pages.blocks.cart-page.fieldset.blocks.label",
            fields: ["top", "left", "right", "footer"],
          },
        ],
      },
    ],
  })
);

export function cartPageDescriptor(): IBlockDescriptor;
export function cartPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartPageDescriptor, cartPageProperties, fieldOrder);
}

export {
  cartPageBlocDefinition,
  cartPageDashboardLayout,
  cartPageProperties,
  cartPageConfig,
  cartPageResolveConfig,
};

export type CartPageConfig = typeof cartPageConfig;
